import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Icon, Confirm } from 'semantic-ui-react'

import RequestInfo from '../Shareds/RequestInfo'
import GeneralInfo from '../Shareds/GeneralInfo'
import POItemInfo from '../Shareds/POItemInfo'
import Attachment from '../Shareds/Attachment'
import ActionCommentModal from '../Shareds/ActionCommentModal'
import CommentHistory from '../Detail/CommentHistory'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { getSpecialApproval, getProjectByCompany } from 'ducks/goa'
import { purchaseOrderUpdatePath } from 'routes'
import {
  validateField,
} from '../helper'
import {
  pouStatus,
} from '../AttributeData'
import { 
  MainBodyContent, 
  CustomButton,
  StatusTag
} from 'components'
import { 
  initializePOUpdate,
  fetchPOComplete,
  updatePOUpdate,
  getPOUGOAWorkFlowEditMode,
  checkPOUpdateInprocess,
  getPOCompleteDetail,
  clearPOCompleteDetail,
  getPOUpdateDetail,
  clearPOUpdateData,
  actionPOUpdate,
  deletePOUpdate,
  closeCreatorSubmitConfirm,
  submitPOUpdate
} from 'ducks/poUpdate'
import { 
  showModal,
} from 'ducks/app'

import { BottomActionsContainer } from './styled'
import r from 'reactotron-react-js'

const EditPOUpdate = props => {

  const { 
    history,
    valueForm,
    change,
    poComplete,
    checkPOUpdate,
    poCompleteDetail,
    isDetail = false,
  } = props

  const [markCall, setMarkCall] = React.useState(0)
  const [actionName, setActionName] = React.useState('')
  const [poValid, setPOValid] = React.useState(false)
  const [showDialogComment,setShowDialogComment] = React.useState(false)
  const [showConfirm, setShowConfirm] = React.useState(false)

  React.useEffect(() => {
    const { match } = props
    window.scrollTo(0,0)
    props.initializePOUpdate(isDetail)
    // props.fetchPOComplete()
    if (match && match.params && match.params.pouId) {
      props.getPOUpdateDetail(match.params.pouId, history, true,'Edit')
    }
    return(()=>{
      props.clearPOUpdateData()
    })
  },[])

  const showAlertPOInprocess = () => {
    props.showModal(
      true, 
      'Alert',
      checkPOUpdate.data.docStatus==0?
      `PO "${checkPOUpdate.data.poSapNumber}" has been crated draft  by ${checkPOUpdate.data.createdByName}.`
      :
      `PO "${checkPOUpdate.data.poSapNumber}"  has been created the request. Please check and complete request no."${checkPOUpdate.data.poUpdateDocNumber}" before submit .`,
      'tiny'
    )
  }

  React.useEffect(() => {
    if(valueForm&&valueForm.poSelect){
      let po = poComplete.data.find(x=>x.poSapNumber == valueForm.poSelect)
      if(po){
        if(valueForm.status==0){
          props.checkPOUpdateInprocess(valueForm.id,po.poSapNumber)
        }
        setMarkCall(markCall+1)
        props.getPOCompleteDetail(po.poSapNumber,'Edit')
        change('companyName',`${po.companyCode} | ${po.companyName}`)
        change('projectName',po.projectName)
        change('poId',po.poId)
        change('purchaseOrderNumber',po.poSapNumber)
        change('goaId',po.goaid)
        change('companyCode',po.companyCode)
        if(props.pouDetail.data.purchaseOrderNumber != valueForm.poSelect){
          change('purchaseGroupCode',po.purchGroup)
        }
      }
    }else{
      change('poId','')
      change('purchaseOrderNumber','')
      change('purchaseGroupCode','')
      change('companyCode','')
      change('projectName','')
    }
  },[(valueForm&&valueForm.poSelect),poComplete])

  React.useEffect(()=>{
    if(checkPOUpdate.data.isInprocess){
      setPOValid(false)
      showAlertPOInprocess()
    }else{
      setPOValid(true)
    }
  },[checkPOUpdate])

  React.useEffect(() => {
    if(valueForm&&valueForm.poSelect){
      if(Object.keys(poCompleteDetail).length>0){
        props.getPOUGOAWorkFlowEditMode({
          creater:valueForm.createdByUser,
          requester:valueForm.requesterUser,
          companyCode:poCompleteDetail.companyCode,
          purchaseGroup:valueForm.purchaseGroupCode,
          poSapNumber:poCompleteDetail.poSapNumber,
          account:valueForm.accounting||false,
          legal:valueForm.legal||false,
          procurement:valueForm.purchasing||false,
          goaId:poCompleteDetail.goaid,
          specialApprovalId:valueForm.specialApprovalId
        })
      }
    }
  },[poCompleteDetail,
    (valueForm&&valueForm.requesterUser),
    (valueForm&&valueForm.accounting),
    (valueForm&&valueForm.legal),
    (valueForm&&valueForm.purchasing),
    (valueForm&&valueForm.specialApprovalId)])

  React.useEffect(()=>{
    if(valueForm&&valueForm.projectId){
      props.getSpecialApproval(valueForm.projectId)
      if(Object.keys(props.specialApprovals).length>0){
        change('specialApprovalId','')
      }
    }
  },[(valueForm&&valueForm.projectId)])

  React.useEffect(()=>{
    if(valueForm&&valueForm.companyCode){
      props.getProjectByCompany(valueForm.companyCode)
    }
  },[(valueForm&&valueForm.companyCode)])

  React.useEffect(()=>{
    if(Object.keys(poCompleteDetail).length>0){
      if(markCall>2){
        change('projectId',poCompleteDetail.projectId)
        change('projectName',poCompleteDetail.projectName)
        change('specialApprovalId',poCompleteDetail.specialApprovalId)
      }
    }
  },[poCompleteDetail])
  
  const onSubmitForm = () => {
    setShowConfirm(false)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      if(actionName=='delete'){
        props.deletePOUpdate(valueForm.id, history)
      }else{
        let errors = validateField(valueForm, actionName)
        if(Object.keys(errors).length){
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        }else{
          if(actionName=='cancel'){
            props.actionPOUpdate({
              docId: valueForm.id,
              sn: valueForm.sn,
              action: 'cancel',
              comment: valueForm.actionComment,
            }, history)
          }else{
            if(poValid){
              props.updatePOUpdate(valueForm, history, (actionName=='submit'||actionName=='reSubmit'))
            }else{
              showAlertPOInprocess()
            }
          }
        }
      }
    })
  } 

  const confirmSubmit = () =>{
    props.submitPOUpdate({id:props.creatorSubmitConfirm.id}, history)
  }

  return (
    <MainBodyContent
      // headerTitle='Update/Cancel PO - Create '
      headerTitle={<React.Fragment>{valueForm&&valueForm.isSpecialCreditTerm&&<Icon size='tiny' name='star' color='yellow'/>}{`Update/Cancel PO - Edit ${valueForm?valueForm.documentNumber?`#${valueForm.documentNumber}`:'':''}`}<span style={{width:'1rem'}}/>{valueForm&&<StatusTag status={valueForm&&valueForm.status} statusName={pouStatus[valueForm?valueForm.status:0]}/>}</React.Fragment>}
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(purchaseOrderUpdatePath)}
            icon="close"
            btnColor="red"
            title="Cancel"
          />
        </div>
      }
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: 'pou',
              content: 'Update/Cancel PO',
              link: true,
              onClick: () => history.push(purchaseOrderUpdatePath),
            },
            { key: 'pouEdit', content: 'Edit', active: true },
          ]}
        />
      }
    >
      <RequestInfo isEdit/>
      
      <GeneralInfo isEdit history={history}/>

      {valueForm&&valueForm.poSelect&&
      <POItemInfo isEdit/>}
      {valueForm&&valueForm.status!=0&&
      <CommentHistory/>}
      <Attachment isEdit change={change}/>
      <Confirm
        size='tiny'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={props.handleSubmit(()=>onSubmitForm())}
      />
      <Confirm
        size='tiny'
        open={props.creatorSubmitConfirm.show}
        content={props.creatorSubmitConfirm.message}
        onCancel={() => props.closeCreatorSubmitConfirm()}
        onConfirm={() => confirmSubmit()}
      /> 
      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            type='button'
            content='Save' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowConfirm(true)
              setActionName('save')
            }}
          />
          <Button 
            type='button'
            content={(valueForm&&valueForm.status!=5)?'Save & Submit':'Save & Re-Submit'}
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              if(valueForm&&valueForm.status!=5){
                setActionName('submit')
                setShowConfirm(true)
              }else{
                setActionName('reSubmit')
                setShowDialogComment(true)
              }
            }}
          />
          {valueForm&&valueForm.status==5&&
          <Button 
            type='button'
            content='Cancel' 
            color='orange' 
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('cancel')
            }}
          />}
          {valueForm&&valueForm.status==0&&
          <Button 
            type='button'
            content='Delete' 
            color='red' 
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('delete')
            }}
          />}
        </BottomActionsContainer>
      </form>
      {showDialogComment&&<ActionCommentModal submit={props.handleSubmit(()=>onSubmitForm())} setShowDialogComment={setShowDialogComment} actionName={actionName}/>}
    </MainBodyContent>
  )

}

const mapStateToProps = (state) => {
  let pouDetail = state.poUpdate.pouDetail
  return ({
    initialValues: {
      ...pouDetail.data,
      poSelect:pouDetail.data.purchaseOrderNumber,
    },
    checkPOUpdate: state.poUpdate.checkPOUpdate,
    specialApprovals:state.goa.specialApprovals,
    poCompleteDetail: state.poUpdate.poCompleteDetail.data,
    creatorSubmitConfirm: state.poUpdate.creatorSubmitConfirm,
    poComplete: state.poUpdate.poComplete,
    valueForm: getFormValues('formPOUpdate')(state),
    pouDetail
  })
}
const mapDispatchToProps = {
  initializePOUpdate,
  fetchPOComplete,
  updatePOUpdate,
  getPOUGOAWorkFlowEditMode,
  checkPOUpdateInprocess,
  getPOCompleteDetail,
  clearPOCompleteDetail,
  getPOUpdateDetail,
  clearPOUpdateData,
  deletePOUpdate,
  actionPOUpdate,
  getSpecialApproval, 
  getProjectByCompany,
  closeCreatorSubmitConfirm,
  submitPOUpdate,
  showModal
}

const contForm = reduxForm({
  form: 'formPOUpdate',
  enableReinitialize: true,
})(EditPOUpdate)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
